import React, { useState } from 'react';
import './App.css';
import Nav from './obj/Nav'
import InfoBar from './obj/InfoBar';
import MulfiViewer from './MulfiViewer';
import {rotate,zif} from './config.js';
const App = () => {
  const [dataName, setDataName] = useState(null);  // 当前选中的文件名
  const [dataPath, setDataPath] = useState(null);  // 当前选中的文件路径
  const [greyValue, setGreyValue] = useState(null);  // 当前选中的灰度值

  return (
    <div className="App" style={{ display:zif ? 'block' : 'grid', backgroundColor: zif ? 'white' : 'black' }}>
      {!zif && <Nav fileNestingFileName={'./fileNesting.json'} setDataName={setDataName} setDataPath={setDataPath}></Nav>}
        <MulfiViewer dataName={dataName} dataPath={dataPath} setGrey={setGreyValue}/>
      {!zif && <InfoBar jsonFileName={'./ontology.json'} greyValue={greyValue} />}
    </div>
  );
}

export default App;
